import { Icon } from "assets/Icon";
import { IconName } from "assets/ImportedIcons";
import { RFX_STATUS } from "utils/constants";
import { cn } from "utils/helpers";

type PreviewOnlyCompProps = {
	icon?: IconName;
	label?: string;
	isRFxClosed?: boolean;
	hasSubmitted?: boolean;
	hasDeadlinePassed?: boolean;
};

export const PreviewOnlyComp = ({
	icon = "eye",
	label = "Preview only",
	isRFxClosed,
	hasSubmitted,
	hasDeadlinePassed,
}: PreviewOnlyCompProps) => {
	// display in red if:-
	// 1. the RFx closed and you did not submit
	// 2. the submission deadline has passed and you did not submit
	// 3. you have submitted but deadline not yet passed
	const showRed =
		(isRFxClosed && !hasSubmitted) ||
		(hasDeadlinePassed && !hasSubmitted) ||
		(!hasDeadlinePassed && hasSubmitted);
	const showBlue = !showRed;

	return (
		<div className="m-auto">
			<div
				className={cn(
					"flex items-center justify-center rounded-full border border-solid p-2 text-center font-medium",
					showRed && "border-[#ffb0b0] bg-utility-error-300 text-red-500",
					showBlue &&
						"border-[#B0CEFF] bg-utility-blue-light-50 text-utility-brand-500"
				)}
				style={{ width: "fit-content", fontSize: "14px" }}
			>
				<div className="flex items-center justify-center rounded-full border border-solid border-[#B0CEFF] bg-white pb-1 pl-3 pr-3 pt-1">
					<div>
						<Icon icon={icon} />
					</div>
					<div className="ml-2">{label}</div>
				</div>
				{showBlue && !hasSubmitted && (
					<>
						<div
							className="ml-2 pr-2"
							style={{ marginTop: "-2px" }}
						>
							Tap "Accept" to agree to the terms and get started
						</div>
					</>
				)}
			</div>
		</div>
	);
};
